import React from "react";
import HeaderPublico from "../components/HeaderPublico";
// import FooterPublico from "../componentes/FooterPublico"; // si lo tienes
import { Outlet } from "react-router-dom";

export default function PublicLayout() {
  return (
    <>
      <HeaderPublico />
      <Outlet />
      {/* <FooterPublico /> */}
    </>
  );
}
